import { useState } from "react";
import { useSelector } from "react-redux";
import useObjectRelationGqlRequest from "./useObjectRelationGqlRequest";

export default function usePublishProject(props) {
  const { gql } = useObjectRelationGqlRequest();
  const userMe = useSelector(state => state.editor.me);

  const [loading, setLoading] = useState(false);

  /*
    attributes: updated attributes to be saved
    scopedProject: latest user scoped(not global) copy of the project object(in web format)
  */
  const publishProject = async (attributes, scopedProject, successMessage) => {
    setLoading(true);
    if (!userMe.objectId) {
      setLoading(false);
      throw Error("empty user meobject id");
    }
    try {
      // create global project with the updated project data
      // add `published` field
      const published = {
        global: true,
        author: {
          id: userMe.id,
          name: userMe.name,
          objectId: userMe.objectId,
        },
        uuid: scopedProject.uuid,
      };
      const globalProject = await gql.mutation.createObject(
        {
          attributes: Object.assign({}, attributes, { published }),
          name: "studio_shared_app",
          isGlobal: true,
        },
        successMessage
      );

      // create owner relation src: user, dest: global project
      await gql.mutation.createRelation(
        {
          type: "owner",
          sourceId: userMe.objectId,
          destId: globalProject.id,
        },
        successMessage
      );
      const sharedProjectAttributes = globalProject.attributesV2;
      sharedProjectAttributes.id = globalProject.id;
      sharedProjectAttributes.uuid = globalProject.uuid;
      sharedProjectAttributes.createdAt = globalProject.createdAt;
      return sharedProjectAttributes;
    } catch (error) {
      return Promise.reject(error);
    } finally {
      setLoading(false);
    }
  };

  const updateObject = async (attributes, globalProject, shareLink, objectId) => {
    let publishedMetadata = JSON.parse(JSON.stringify(attributes?.published_metadata || {}));
    if (!publishedMetadata) {
      publishedMetadata = {
        original: true,
        stripe_product_id: null,
        stripe_price_id: null,
        uuid: null,
      };
    }
    publishedMetadata.uuid = globalProject.uuid;
    if (shareLink) {
      publishedMetadata.published_at = globalProject.createdAt;
      publishedMetadata.link = shareLink;

      // // FIXME: 直接放入 publishedMetadata 存在bug,会导致 currentId 发生变化
      // publishedMetadata = {
      //   ...publishedMetadata,
      //   v2: [ ...(publishedMetadata?.v2 || []), omit(publishedMetadata, 'v2') ]
      // }
      attributes = props?.assignPreviewAppData?.(attributes, { publishedMetadata });
    }
    const updateObject = await gql.mutation.updateObject(parseInt(objectId), {
      name: "studio_project",
      attributes: Object.assign({}, attributes, { published_metadata: publishedMetadata }),
    });

    const updateProjectAttributes = updateObject.attributesV2;
    updateProjectAttributes.id = updateObject.id;
    updateProjectAttributes.uuid = updateObject.uuid;
    updateProjectAttributes.globaluuid = globalProject.uuid;
    return updateProjectAttributes;
  };

  return {
    publishProject,
    updateObject,
    loading,
  };
}
